import React from 'react';
import { LUX_CSS, useLuxMotion } from './LuxShared';
import ContactFormX from './contact_form_contact_us';

const OFFICES = [
  { region: 'APAC — India', city: 'Bengaluru', line: 'Bridge+, ITPB, Whitefield' },
  { region: 'Americas — USA', city: 'Charlotte', line: 'North Carolina' },
  { region: 'Europe — Switzerland', city: 'Zurich', line: 'Switzerland' },
];

const ContactLux = () => {
  const rootRef = useLuxMotion();
  return (
    <div className="fx-root" ref={rootRef}>
      <style>{LUX_CSS}</style>
      <style>{`
        .cx-split { display:grid; grid-template-columns:1fr 1fr; gap:56px; align-items:start; }
        .cx-panel { background:#fff; border:1px solid var(--fx-line); border-radius:24px; padding:8px;
          box-shadow:0 26px 60px -34px rgba(19,26,38,.4); overflow:hidden; position:relative; }
        .cx-panel::before { content:''; position:absolute; top:0; left:0; right:0; height:4px;
          background:linear-gradient(90deg,var(--fx-fire),var(--fx-blue)); z-index:2; }
        .cx-panel .contact-form-container { max-width:none !important; margin:0 !important; padding:34px 36px 38px !important;
          background:transparent !important; box-shadow:none !important; border-radius:0 !important; }
        .cx-panel .contact-form { box-shadow:none !important; border:none !important; background:transparent !important; }
        .cx-panel .form-title { text-align:left !important; font-size:24px !important; font-weight:800 !important;
          color:var(--fx-ink) !important; letter-spacing:-.01em; margin-bottom:6px !important; }
        .cx-panel .contact-submit-button { background:var(--fx-fire) !important; border-radius:999px !important;
          box-shadow:0 12px 34px rgba(249,52,0,.32) !important; font-weight:600 !important; }
        .cx-panel .contact-submit-button:hover { background:var(--fx-fire-dark) !important; }
        .cx-panel .success-message { padding:34px 36px; }
        .cx-panel .success-message h2 { font-size:24px; font-weight:800; color:var(--fx-ink); margin-bottom:10px; }
        .cx-panel .success-message p { color:var(--fx-body); line-height:1.65; }
        .cx-lead h2 { font-size:clamp(26px,3.4vw,40px); font-weight:800; letter-spacing:-.015em; color:var(--fx-ink); line-height:1.22; }
        .cx-lead h2 .fx-accent { color:var(--fx-fire); }
        .cx-lead p { color:var(--fx-body); font-size:16px; line-height:1.7; margin-top:16px; }
        .cx-direct { margin-top:30px; display:flex; flex-direction:column; gap:12px; }
        .cx-direct a { display:inline-flex; align-items:center; gap:12px; text-decoration:none; color:var(--fx-ink);
          font-weight:600; font-size:15px; background:#fff; border:1px solid var(--fx-line); border-radius:14px; padding:14px 18px;
          transition:border-color .25s, transform .25s, box-shadow .25s; }
        .cx-direct a:hover { border-color:var(--fx-fire); color:var(--fx-fire); transform:translateX(4px); box-shadow:0 12px 30px -18px rgba(249,52,0,.6); }
        .cx-direct .cx-tag { font-family:'Courier New',monospace; font-size:10px; letter-spacing:.2em; text-transform:uppercase;
          color:var(--fx-faint); min-width:64px; }
        .cx-offices { display:grid; grid-template-columns:repeat(3,1fr); gap:22px; }
        .cx-office { position:relative; background:#fff; border:1px solid var(--fx-line); border-radius:18px; padding:26px 24px;
          transition:transform .35s cubic-bezier(.16,.84,.32,1), box-shadow .35s, border-color .3s; }
        .cx-office:hover { transform:translateY(-6px); border-color:var(--fx-blue); box-shadow:0 26px 56px -30px rgba(19,26,38,.4); }
        .cx-office .cx-reg { font-family:'Courier New',monospace; font-size:10.5px; letter-spacing:.2em; text-transform:uppercase; color:var(--fx-blue); }
        .cx-office h3 { font-size:22px; font-weight:800; color:var(--fx-ink); margin:10px 0 6px; }
        .cx-office p { font-size:14px; color:var(--fx-body); line-height:1.6; }
        .cx-office .cx-pin { position:absolute; right:22px; top:22px; width:9px; height:9px; border-radius:50%;
          background:var(--fx-fire); box-shadow:0 0 0 5px rgba(249,52,0,.14); }
        @media (max-width:980px) { .cx-split { grid-template-columns:1fr; gap:36px; } .cx-offices { grid-template-columns:1fr; } }
      `}</style>

      <section className="fx-hero">
        <video className="fx-hero-video" muted loop playsInline autoPlay preload="auto" src="/nh-media/contact-tech.mp4" />
        <div className="fx-hero-scrim" />
        <div className="fx-hero-inner">
          <h1 className="fx-reveal">Let's build something <span className="fx-accent">worth shipping.</span></h1>
          <p className="fx-reveal">Tell us what you're trying to launch. You'll hear back from an engineer, not a sales queue.</p>
        </div>
      </section>

      <section className="fx-section">
        <div className="fx-wrap">
          <div className="cx-split">
            <div className="cx-lead fx-reveal">
              <h2>Start the conversation. <span className="fx-accent">We'll keep it short.</span></h2>
              <p>
                Send us the outline — the problem, the deadline, whatever exists today. We'll come back with an honest
                view of scope, sequence and what the fastest credible path to launch looks like.
              </p>
              <div className="cx-direct">
                <a href="mailto:hello@firebucks.ai">
                  <span className="cx-tag">Email</span> hello@firebucks.ai
                </a>
                <a href="https://www.linkedin.com/company/firebucks" target="_blank" rel="noopener noreferrer">
                  <span className="cx-tag">LinkedIn</span> Firebucks on LinkedIn
                </a>
              </div>
            </div>
            <div className="cx-panel fx-reveal">
              <ContactFormX />
            </div>
          </div>
        </div>
      </section>

      <section className="fx-section fx-soft">
        <div className="fx-wrap">
          <div className="fx-head fx-reveal">
            <h2>Three hubs. <span className="fx-accent">One team.</span></h2>
            <p>Delivery follows the sun so your build keeps moving.</p>
          </div>
          <div className="cx-offices">
            {OFFICES.map((o) => (
              <div key={o.region} className="cx-office fx-pop">
                <span className="cx-pin" />
                <div className="cx-reg">{o.region}</div>
                <h3>{o.city}</h3>
                <p>{o.line}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactLux;
